<template>
    <div class="flex items-center text-sm gap-2">
        <div class="whitespace-nowrap">
            Showing {{ rangeLow }} - {{ rangeHigh }} of {{ total }}
        </div>
        <button
            class="flex items-center justify-center text-white rounded-full w-8 h-8"
            :class="{
                'bg-blue-200 text-gray-400 cursor-not-allowed': page == 1,
                'bg-blue-500 hover:bg-blue-400': page != 1,
            }"
            :disabled="page == 1"
            @click="prevPage"
        >
            <SvgIcon icon="arrow-left" size="xs" weight="bold" />
        </button>
        <button
            class="flex items-center justify-center text-white rounded-full w-8 h-8"
            :class="{
                'bg-blue-200 text-gray-400 cursor-not-allowed': page == pages,
                'bg-blue-600 hover:bg-blue-800': page != pages,
            }"
            :disabled="page == pages"
            @click="nextPage"
        >
            <SvgIcon icon="arrow-right" size="xs" weight="bold" />
        </button>
    </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
    props: {
        modelValue: Number,
        total: Number,
        perPage: [Number, String],
    },
    data(): any {
        return {
            page: null,
        };
    },
    computed: {
        perPageNumber() {
            return Number(this.perPage);
        },
        pages() {
            return Math.ceil(this.total / this.perPageNumber);
        },
        rangeLow() {
            return this.perPageNumber * (this.page - 1) + 1;
        },
        rangeHigh() {
            return Math.min(this.perPageNumber * this.page, this.total);
        },
    },
    methods: {
        nextPage() {
            this.page++;
            this.$emit("update:modelValue", this.page);
        },
        prevPage() {
            this.page--;
            this.$emit("update:modelValue", this.page);
        },
    },
    mounted() {
        this.page = this.modelValue;
    },
    watch: {
        modelValue(value) {
            this.page = value;
        },
    },
});
</script>
